import script from "./SkeletonLoaders.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonLoaders.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonLoaders.vue?vue&type=style&index=0&id=b7b8bf6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7b8bf6c"]])

export default __exports__